import { useState } from "react";
import "./Console.css";
import ServerRequests from "../../../../../../../Services/Api/ServersRequests.ts";
import { AddToastNotification } from "../../../../../../../Services/ToastNotification/ToastNotificationManager";

const Console = ({serverId}) => {
    const serverRequests = new ServerRequests();

    const [command, setCommand] = useState("");

    const executeCommand = () => {
        if(command.length <= 0)
        {
            AddToastNotification("Musisz wpisać polecenie!", 0);
            return;
        }

        serverRequests.ExecuteCommand(serverId, command, () => {
            AddToastNotification("Polecenie wysłane do wykonania!", 1);
            setCommand("")
        });
    }

    return (
        <>
            <h3 className="text-center">Console</h3>
            <div className="consoleField">

            </div>
            <div className="consoleInput">
                <input value={command} onChange={(e) => setCommand(e.target.value)} placeholder="Enter command..." type="text" className="input w-90p h-10"/>
                <button className="w-10p h-10 mt-1" onClick={() => executeCommand()}>Send</button>
            </div>
        </>
    )
}

export default Console;